// Steps to add a new component (XYZ) to the white-list of InnerToolbarItem
// 1. Create InnerToolbarXYZ in this file as follows
//    export interface InnerToolbarXYZ extends CustomToolbarItemProps, Omit<XYZProps, 'type'> {
//      type: 'XYZ';
//      xyzType: XYZProps['type']; // Only add this line if XYZProps['type'] exists
//    }
// 2. Union InnerToolbarXYZ to InnerToolbarItem
// 3. Add the type string literal 'XYZ' to InnerToolbarItemTypes
// 4. Add the type string literal 'XYZ' to FocusableItemTypes if that item is focusable
// 5. Create ToolbarXYZ in ToobarItem.ts as follows
//    export interface ToolbarXYZ extends ComponentOverflowConfig,
//        Omit<InnerToolbarXYZProps, keyof ComponentOverflowConfig> {
//          xyzOverflowPriority: InnerToolbarXYZProps['overflowPriority']; // Only add this line if XYZProps['overflowPriority'] exists
//          xyzMenuItemText: InnerToolbarXYZProps['menuItemText']; // Only add this line if XYZProps['menuItemText'] exists
//    }
// 6. Union InnerToolbarXYZ to ToolbarItem
// 7. Add mapping from XYZProps to XYZ in mapInnerToolbarItemToReactNode function in InnerToolbarItem.tsx
// 8. Add default overflow config for XYZ in getOverflowConfig function in Toolbar.tsx
/* Internal Usage only */
/* Internal Usage only */
// HelpPoppup always has vairant set to 'toolbar' when used in Toolbar
export const InnerToolbarItemTypes = ['Button', 'PredefinedButton', 'Checkbox', 'Heading', 'BadgeButton', 'MenuButton', 'BaseMenuButton', 'ToolbarSeparator', 'Select', 'SelectWithLabels', 'Label', 'SegmentedButton', 'ToggleButton', 'HelpPopup', 'Image', 'ObjectMarker', 'SplitButton', 'UndoRedo', 'ObjectSwitcher'];
export const FocusableItemTypes = ['Button', 'PredefinedButton', 'MenuButton', 'BaseMenuButton', 'SegmentedButton', 'Select', 'SelectWithLabels', 'HelpPopup', 'BadgeButton', 'ToggleButton', 'Checkbox', 'ObjectMarker', 'SplitButton', 'UndoRedo', 'ObjectSwitcher', 'FileUploader'];
//# sourceMappingURL=types.js.map